const defaultImage =
  "https://cdn.shopify.com/s/files/1/0609/2924/5364/files/Group_647.svg?v=1710259550";

const selectors = {
  colorPicker: ".color-selection__grid-item",
  selectorImage: ".color-selection__image",
  colorsContainer: ".color-selection__selection-container",
  color: ".color-selection__selection-grid-item",
  colorImage: ".color-selection__image",
  removeColorIcon: ".remove-color",
  selectionImageTop: ".color-selection__image--top",
  ctaDisabled: "#MainPaymentContainer .disabled-text",
  addToCart: "#MainPaymentContainer #AddToCart",
  colorToolTip: ".color-tool-tip",
  categoryName: ".category-name",
  categories: ".categories",
  categoriesWrapper: ".categories-wrapper",
  activeGridItem: ".color-selection__grid-item.active",
  hiddenOverlay: ".hidden-overlay",
  hiddenContainer: ".hidden-container",
  colorPickerId: "picker-color-id",
  addToCartId: "AddToCart",
  addToCartSpan: ".loader-button__text",
  disabledCtaSpan: ".disabled-text",
  ctaWrapper: ".product-form__buy-buttons",
  progress: ".progress",
  modalHeader: ".color-choose-modal-header",
  modalTitle: ".modal-title",
  buyButtonsWrapper: ".buy-buttons-wrapper",
  selectedColorsNum: ".selected-colors-number",
  colorPickerItem: ".selectors-image",
  colorName: ".color-name",
  closeModalIcon: ".close-modal-icon",
  announcementBar: "shopify-section-announcement-bar",
  pageHeader: "shopify-section-header",
  colorSelectionContainer: ".color-selection__container",
  colorsGrid: ".colors-grid",
  kitsContainer: ".kits-container",
  kitOption: ".kit-option",
  totalColorsToSelect: ".total-colors-to-select",
};

const colorSelectors = document.querySelectorAll(selectors.colorPicker);
const colorPicker = document.getElementById(selectors.colorPickerId);
const ctaWrapper = document.querySelector(selectors.ctaWrapper);
const ctaButton = document.getElementById(selectors.addToCartId);
const progress = document.querySelector(selectors.progress);
const modalHeader = document.querySelector(selectors.modalHeader);
const mainWrapper = document.querySelector(selectors.buyButtonsWrapper);
const selectedColorsNum = document.querySelector(selectors.selectedColorsNum);
const modalTitle = document.querySelector(selectors.modalTitle);
const colorPickerItems = document.querySelectorAll(selectors.colorPickerItem);
const announcementBar = document.getElementById(selectors.announcementBar);
const pageHeader = document.getElementById(selectors.pageHeader);
const body = document.querySelector("body");
let openedSelectorIndex;
let collectionToShow = "";
let isMobile = window.innerWidth <= 768;
let selectedColors = Array.from({ length: totalColorsToPick }, () => undefined);
const kitsContainer = document.querySelector(selectors.kitsContainer);
const kitOptions = document.querySelectorAll(selectors.kitOption);
const totalColorsToSelect = document.querySelector(
  selectors.totalColorsToSelect
);
const {
  color: colorTag,
  greatSelection,
  pickYourColors,
  chooseYourColors,
  totalColorsSelected,
} = translations;

window.addEventListener("resize", function () {
  isMobile = window.innerWidth <= 768;
  mobileStickyCTA();
});

window.addEventListener("scroll", function () {
  mobileStickyCTA();
});

document.addEventListener("DOMContentLoaded", function () {
  showColorSelectots();
  toggleColorsGrid();
  handleOutsideClicks();
  // setDefaultCollection();
  toggleColorCollections();
  onModalClose();
  pickColorsCta();
});

const mobileStickyCTA = () => {
  if (isMobile) {
    const hiddenContainer = document.querySelector(selectors.hiddenContainer);
    const pickerContainer = document.getElementById(selectors.colorPickerId);
    let wrapper = totalColorsToPick ? pickerContainer : hiddenContainer;

    const observer = new IntersectionObserver((entries) => {
      let isIntersecting = false;
      entries.forEach((entry) => {
        if (entry.isIntersecting) isIntersecting = true;
      });

      const mainWrapperBottom = wrapper.getBoundingClientRect().bottom;
      const scrollY = window.scrollY || window.pageYOffset;
      const mainWrapperBottomPosition =
        mainWrapperBottom + scrollY - window.innerHeight;
      const pastMainCTA = scrollY > mainWrapperBottomPosition;

      if (!isIntersecting && pastMainCTA) {
        ctaButton.classList.add("sticky");
      } else {
        ctaButton.classList.remove("sticky");
      }
    });

    if (wrapper) observer.observe(wrapper);
  } else {
    ctaButton.classList.remove("sticky");
  }
};

const toggleColorsGrid = () => {
  colorSelectors.forEach((colorSelector, index) => {
    const selectorImage = colorSelector.querySelector(selectors.selectorImage);
    const colorsGrid = colorSelector.querySelector(selectors.colorsContainer);
    // open/close colors grid
    selectorImage.addEventListener("click", () => {
      const isOpen = colorsGrid.style.display === "flex";
      if (!isOpen) {
        openPicker(index);
        const spanElements = ctaButton.querySelectorAll("span");
        spanElements.forEach(function (span) {
          span.style.display = "none";
        });
        const addToCartText = ctaButton.querySelector(selectors.addToCartSpan);
        addToCartText.style.display = "flex";
        if (isMobile) {
          announcementBar.classList.add("hidden");
          pageHeader.classList.add("hidden");
          body.classList.add("no-scroll");
        }
        setColorsGridHeight();
      } else if (isMobile) {
        announcementBar.classList.remove("hidden");
        pageHeader.classList.remove("hidden");
        body.classList.remove("no-scroll");
      }
    });
    // pick a color
    const colors = colorSelector.querySelectorAll(selectors.color);
    colors.forEach((color) => {
      color.addEventListener("click", () => {
        const image = color.querySelector(selectors.colorImage);
        const id = image.getAttribute("data-variant");
        const name = image.getAttribute("data-name");
        const imageUrl = image.getAttribute("data-file");
        selectorImage.style.backgroundImage = `url(${imageUrl})`;
        selectorImage.style.backgroundSize = "70%";
        selectedColors[index] = { id, name };
        const removeColorIcon = colorSelector.querySelector(
          selectors.removeColorIcon
        );
        removeColorIcon.style.display = "inline-block";
        const colorName = colorSelector.querySelector(selectors.colorName);
        colorName.innerHTML = name.split("|")[0];
        setProgress();
        // open next free available space
        const hasMoreColorsToChoose = selectedColors.includes(undefined);
        if (hasMoreColorsToChoose) {
          const colorsGrid = colorSelector.querySelector(
            selectors.colorsContainer
          );
          colorsGrid.style.display = "none";
          colorSelector.style.zIndex = "1";
          const nextColorSelectorIndex = findNextEmptySelector();

          const nextColorSelector = colorSelectors[nextColorSelectorIndex];
          openedSelector = nextColorSelectorIndex;
          nextColorSelector.style.zIndex = "10";
          openPicker(nextColorSelectorIndex);
          toggleColorCollections();
        } else {
          enableCTA();
          colorPickerItems[index].style.borderColor = "#e5e7eb";
        }
      });
    });
    // unselect color
    const removeColorIcon = colorSelector.querySelectorAll(
      selectors.removeColorIcon
    );
    const colorName = colorSelector.querySelector(selectors.colorName);
    removeColorIcon.forEach((icon) => {
      icon.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        icon.style.display = "none";
        selectorImage.style.backgroundImage = `url(${defaultImage})`;
        selectorImage.style.backgroundSize = "104%";
        selectedColors[index] = undefined;
        colorName.innerHTML = colorTag + (index + 1);
        openedSelectorIndex = index;

        const pickerModal = document.querySelector(".color-choose-modal");
        const isModalOpen = !!pickerModal;
        if (isModalOpen) {
          const colorsGrid = colorSelector.querySelector(
            selectors.colorsContainer
          );
          colorsGrid.style.display = "none";
          colorSelector.style.zIndex = "1";
          const nextColorSelectorIndex = findNextEmptySelector();

          const nextColorSelector = colorSelectors[nextColorSelectorIndex];
          openedSelector = nextColorSelectorIndex;
          nextColorSelector.style.zIndex = "10";
          openPicker(nextColorSelectorIndex);
        } else pickColorsCta();
        setProgress();
      });
    });
  });
};

const findNextEmptySelector = () => {
  const startIndex =
    openedSelectorIndex + 1 === selectedColors.length
      ? 0
      : openedSelectorIndex || 0;
  for (let i = startIndex; i < selectedColors.length; i++) {
    if (selectedColors[i] === undefined) return i; // Return the index of the next undefined value
  }
  for (let i = 0; i < startIndex; i++) {
    if (selectedColors[i] === undefined) return i; // Return the index of the next undefined value
  }
  return -1; // Return -1 if no undefined value is found after the startIndex
};

const handleOutsideClicks = () => {
  document.body.addEventListener("click", function (event) {
    const target = event.target;
    if (
      target.matches(selectors.closeModalIcon) ||
      target.matches(selectors.hiddenOverlay)
    )
      closeModal();
  });
};

const closeModal = () => {
  // Remove the "active" class, hide the selection container, and remove the "color-choose-active" class from the body
  document
    .querySelectorAll(".color-selection__grid-item.active")
    .forEach(function (element) {
      element.classList.remove("active");
    });

  document
    .querySelectorAll(".color-selection__selection-container")
    .forEach(function (container) {
      container.style.display = "none";
    });

  document.body.classList.remove("color-choose-active");
  toggleOverlay(false);
  const colorSelectors = document.querySelectorAll(
    ".color-selection__grid-item"
  );
  colorSelectors.forEach((s) => (s.style.zIndex = "1"));
  colorPickerItems.forEach((s) => (s.style.borderColor = "#e5e7eb"));
  openedSelectorIndex = undefined;

  colorPicker.classList.remove("color-choose-modal");
  ctaButton.classList.remove("fixedCta");
  if (isMobile) {
    announcementBar.classList.remove("hidden");
    pageHeader.classList.remove("hidden");
    body.classList.remove("no-scroll");
  }

  const allColorsSelected = selectedColors.every((s) => !!s);
  if (!allColorsSelected) pickColorsCta();
  else enableCTA();
};

const toggleOverlay = (show = true) => {
  const hiddenOverlay = document.querySelector(selectors.hiddenOverlay);
  if (show) hiddenOverlay.style.display = "block";
  else hiddenOverlay.style.display = "none";
};

const pickColorsCta = () => {
  const spanElements = ctaButton.querySelectorAll("span");
  spanElements.forEach(function (span) {
    span.style.display = "none";
  });

  if (totalColorsToSelect) {
    const spanElement = document.createElement("span");
    spanElement.textContent = pickYourColors;
    ctaButton.appendChild(spanElement);
  } else {
    const addToCartText = ctaButton.querySelector(selectors.addToCartSpan);
    addToCartText.style.display = "flex";
  }

  ctaButton.removeAttribute("disabled");

  ctaButton.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (ctaButton.classList.contains("sticky")) scrollToElement(mainWrapper);

    const colorIndexToPick = findNextEmptySelector();
    openPicker(colorIndexToPick);

    const spanElements = ctaButton.querySelectorAll("span");
    spanElements.forEach(function (span) {
      span.style.display = "none";
    });
    const addToCartText = ctaButton.querySelector(selectors.addToCartSpan);
    addToCartText.style.display = "flex";
    if (isMobile && totalColorsToSelect) {
      announcementBar.classList.add("hidden");
      pageHeader.classList.add("hidden");
      body.classList.add("no-scroll");
    }
    if (totalColorsToSelect) setColorsGridHeight();
    else addRelated(this);
  });
};

const scrollToElement = (element) => {
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    console.error("Element not found");
  }
};

const enableCTA = () => {
  ctaButton.removeAttribute("disabled");
  addToCartOnClick();
};

const toggleColorCollections = () => {
  setDefaultCollection();
  renderCollectionColors();
  const collections = document.querySelectorAll(selectors.categoryName);

  collections.forEach((collection, index) => {
    collection.addEventListener("click", () => {
      collections.forEach((c) => c.classList.remove("active"));
      const newCollection = collection.getAttribute("data-name");
      collectionToShow = newCollection.trim();
      renderCollectionColors();
      collection.classList.add("active");
    });
  });
};

const setDefaultCollection = () => {
  colorSelectors.forEach((colorSelector) => {
    const categoryNames = colorSelector.querySelectorAll(
      selectors.categoryName
    );
    categoryNames.forEach((c) => c.classList.remove("active"));
    categoryNames[0].classList.add("active");
    collectionToShow = categoryNames[0].getAttribute("data-name");
  });
};

const renderCollectionColors = () => {
  const allColors = document.querySelectorAll(selectors.color);
  allColors.forEach((color) => {
    const colorCollection = color.getAttribute("data-name");
    if (collectionToShow === colorCollection)
      color.style.display = "inline-block";
    else color.style.display = "none";
  });
};

const setProgress = () => {
  const totalColors = selectedColors.length;
  const pickedColors = selectedColorsNumber();
  const percentage = pickedColors / totalColors;
  progress.style.transform = `scaleX(${percentage})`;
  selectedColorsNum.innerHTML = pickedColors;
  if (pickedColors === totalColors) {
    modalHeader.classList.add("success");
    modalTitle.innerHTML = greatSelection;
  } else {
    const unfilledColors = 0;
    modalHeader.classList.remove("success");
    modalTitle.innerHTML = chooseYourColors.replace(/\d+/, totalColorsToPick);
  }
};

const selectedColorsNumber = () => {
  return selectedColors.filter((c) => !!c).length;
};

const onModalClose = () => {
  const closeIcon = document.querySelector(selectors.closeModalIcon);
  if (closeIcon)
    closeIcon.addEventListener("click", () => {
      closeModal();
    });
};

const openPicker = (index) => {
  if (index < 0) return;
  const colorSelector = colorSelectors[index];
  const colorsGrid = colorSelector.querySelector(selectors.colorsContainer);
  openedSelectorIndex = index;
  toggleOverlay();
  if (colorSelectors && colorSelectors.length)
    colorSelectors.forEach((s) => (s.style.zIndex = "1"));
  colorSelector.style.zIndex = "10";
  const colorGrids = document.querySelectorAll(selectors.colorsContainer);
  colorGrids.forEach((c) => (c.style.display = "none"));
  colorPicker.classList.add("color-choose-modal");
  ctaButton.classList.add("fixedCta");
  ctaButton.disabled = true;
  colorsGrid.style.display = "flex";
  toggleColorCollections();
  colorPickerItems.forEach((s) => (s.style.borderColor = "#e5e7eb"));
  colorPickerItems[index].style.borderColor = "#aaa";
  ctaButton.style.bottom = "";
  ctaButton.style.position = "";
  const allColorsSelected = selectedColors.every((s) => !!s);
  if (allColorsSelected) ctaButton.removeAttribute("disabled");
};

const setColorsGridHeight = () => {
  if (!isMobile) return;
  if (isMobile && !totalColorsToSelect) return;
  const modalHeaderHeight = 100;
  const categoriesNamesHeight = 55;
  const colorSelectionContainer = document.querySelector(
    selectors.colorSelectionContainer
  );
  console.log("totalColorsToSelect: ", totalColorsToSelect);
  const selectionContainerHeight = colorSelectionContainer.offsetHeight;
  const topMargin = 80;
  // const cta = 75;
  const filledSpace =
    modalHeaderHeight +
    categoriesNamesHeight +
    selectionContainerHeight +
    topMargin; // + cta;
  const colorsGrid = document.querySelectorAll(selectors.colorsGrid);
  colorsGrid.forEach((c) => {
    c.style.maxHeight = `calc(100vh - ${filledSpace}px)`;
  });

  handleScrollArrows(colorSelectionContainer);
};

//////////////////////////////////////////////////////////////
//////////////////////Add to cart////////////////////////////
//////////////////////////////////////////////////////////////

function generateUID() {
  var firstPart = (Math.random() * 46656) | 0;
  var secondPart = (Math.random() * 46656) | 0;
  firstPart = ("000" + firstPart.toString(36)).slice(-3);
  secondPart = ("000" + secondPart.toString(36)).slice(-3);
  return firstPart + secondPart;
}

function getProductId() {
  const kitsOption = document.querySelector(".kit-option");
  if (!!kitsOption) {
    const selectedKit = document.querySelector(".kit-option.active");
    return selectedKit.getAttribute("productId");
  }
  return document.querySelector('.product-form__buy-buttons input[name="id"]')
    .value;
}

async function addRelated($that) {
  const set_id = generateUID();
  const productId = getProductId();

  const properties = {
    "_bundle-parent": true,
    _set: set_id,
    _variants_set: "",
  };

  selectedColors.forEach((color, index) => {
    const colorKey = `${colorTag} ${index + 1}`;
    properties[colorKey] = color.name;
    if (index > 0) properties._variants_set += "__";
    properties._variants_set += `${color.id}:${
      selectedColors.filter((c) => c.id === color.id).length
    }`;
  });

  const payload = {
    items: [
      {
        quantity: 1,
        id: productId,
        properties,
      },
    ],
    sections: ["mini-cart"],
  };

  const response = await fetch(
    `${window.themeVariables.routes.cartAddUrl}.js`,
    {
      body: JSON.stringify(payload),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    }
  );

  const responseJson = await response.json();

  if (response.ok) {
    $that.dispatchEvent(
      new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty("items")
            ? responseJson["items"][0]
            : responseJson,
        },
      })
    );
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
      async (response2) => {
        const cartContent = await response2.json();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          })
        );
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart:
                window.themeVariables.settings.cartType === "drawer" &&
                $that.closest(".drawer") === null,
            },
          })
        );
      }
    );
  }

  $that.dispatchEvent(
    new CustomEvent("cart-notification:show", {
      bubbles: true,
      cancelable: true,
      detail: {
        status: response.ok ? "success" : "error",
        error: responseJson["description"] || "",
      },
    })
  );

  if (isMobile) {
    announcementBar.classList.remove("hidden");
    pageHeader.classList.remove("hidden");
    body.classList.remove("no-scroll");
  }
}

const addToCartOnClick = () => {
  ctaButton.addEventListener("click", async function (event) {
    event.preventDefault();
    event.stopPropagation();

    colorPicker.classList.remove("color-choose-modal");
    ctaWrapper.classList.remove("fixedCtaWrapper");
    toggleOverlay(false);
    ctaButton.classList.remove("fixedCta");
    ctaButton.style.bottom = "0";
    ctaButton.style.position = "relative";

    colorSelectors.forEach((colorSelector, index) => {
      const selectorImage = colorSelector.querySelector(
        selectors.selectorImage
      );
      const colorsGrid = colorSelector.querySelector(selectors.colorsContainer);
      colorsGrid.style.display = "none";
      colorSelector.style.zIndex = "1";
    });

    addRelated(this);
  });
};

//////////////////////////////////////////////////////////////////////////////////////////////
///////////////////KITS///////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////

const showColorSelectots = () => {
  setGrid();
  setActiveKitOption(0);
  toggleColorSelectorsVisiblility();
  setTotalColorsToPick();
};

const setGrid = () => {
  if (!kitsContainer) return;
  if (kitOptions.length % 3 === 0) kitsContainer.classList.add("grid3");
  else kitsContainer.classList.add("grid2");
};

const setTotalColorsToPick = () => {
  kitOptions.forEach((kitOption, index) => {
    kitOption.addEventListener("click", () => {
      const quantity = kitOption.getAttribute("quantity");
      const variantId = kitOption.getAttribute("productid");
      console.log("totalColorsToPick: ", totalColorsToPick);
      totalColorsToPick = quantity;
      toggleColorSelectorsVisiblility();
      setActiveKitOption(index);
      resetSelectedColors();
      setProgress();

      const productVariantElement = document.querySelector("product-variants");
      productVariantElement.selectVariant(variantId, true);
    });
  });
};

const toggleColorSelectorsVisiblility = () => {
  colorSelectors.forEach((colorSelector, index) => {
    if (index < totalColorsToPick) {
      colorSelector.style.display = "block";
    } else {
      colorSelector.style.display = "none";
    }
  });
};

const setActiveKitOption = (index) => {
  kitOptions.forEach((kit, i) => {
    if (i === index) kit.classList.add("active");
    else kit.classList.remove("active");
  });
  if (totalColorsToSelect)
    totalColorsToSelect.innerHTML = totalColorsSelected.replace(
      /\d+/,
      totalColorsToPick
    );
};

const resetSelectedColors = () => {
  selectedColors = Array.from({ length: totalColorsToPick }, () => undefined);
  colorSelectors.forEach((colorSelector, index) => {
    const selectorImage = colorSelector.querySelector(selectors.selectorImage);
    selectorImage.style.backgroundImage = `url(${defaultImage})`;
    selectorImage.style.backgroundSize = "104%";
    const removeColorIcons = colorSelector.querySelectorAll(
      selectors.removeColorIcon
    );
    removeColorIcons.forEach((icon) => {
      icon.style.display = "none";
    });
    const colorName = colorSelector.querySelector(selectors.colorName);
    colorName.innerHTML = colorTag + (index + 1);
  });
};

///////////////////////////////////////
//////////Arrows///////////////////////
///////////////////////////////////////

function handleScrollArrows(container) {
  const leftArrow = container.querySelector(".arrow.left");
  const rightArrow = container.querySelector(".arrow.right");

  // setArraysTopPosition(container, leftArrow, rightArrow);

  const isContainerScrollable = isScrollable(container);

  if (!isContainerScrollable) {
    leftArrow.style.opacity = "0";
    rightArrow.style.opacity = "0";
  } else {
    leftArrow.style.opacity = "0";
    rightArrow.style.opacity = "1";
  }

  leftArrow.addEventListener("click", () => {
    container.scrollBy({ left: -200, behavior: "smooth" });
  });

  rightArrow.addEventListener("click", () => {
    container.scrollBy({ left: 200, behavior: "smooth" });
  });

  container.addEventListener("scroll", function () {
    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    if (container.scrollLeft >= maxScrollLeft - 10)
      rightArrow.style.opacity = "0";
    else rightArrow.style.opacity = "1";

    if (container.scrollLeft < 10) leftArrow.style.opacity = "0";
    else leftArrow.style.opacity = "1";
  });
}

// function setArraysTopPosition(container, leftArrow, rightArrow) {
//   const colorPicker = container.querySelector(".color-selection__grid-item");
//   console.log("colorPicker: ", colorPicker);
//   const colorPickerTop = colorPicker.getBoundingClientRect().top;
//   console.log("colorPickerTop: ", colorPickerTop);
//   const colorPickerHeight = colorPicker.offsetHeight;
//   console.log("colorPickerHeight: ", colorPickerHeight);
//   const arraysTop = colorPickerTop + colorPickerHeight / 2;

//   leftArrow.style.top = arraysTop + "px";
//   rightArrow.style.top = arraysTop + "px";
// }

function isScrollable(container) {
  return container.scrollWidth > container.clientWidth;
}

/////////////////////////////////////////
// this is to hide the scroll initially//
// and show it once we start scrolling //
/////////////////////////////////////////

const scrollArea = document.querySelector(".color-selection__container");
const modal = document.getElementById("picker-color-id");

scrollArea.addEventListener("scroll", function () {
  modal.classList.add("scrolling");
});

let isScrolling;
scrollArea.addEventListener("scroll", function () {
  // Clear the timeout if it's already set
  window.clearTimeout(isScrolling);

  // Set a timeout to remove the class after scrolling has stopped
  isScrolling = setTimeout(function () {
    modal.classList.remove("scrolling");
  }, 700);
});
